import { EntityId } from "@jackfruit/common"
import { useState } from "react"
import { useProcessActions } from "~/hooks/useProcessActions"
import { wait } from "~/services/Utils"
import { CloudImage } from "../CloudProviderTypes"
import { useCloudProviderContext } from "./useCloudProviderContext"

export const useCloudProviderActions = () => {
  const {
    setIsImportingImages,
    isImportingImages,
    closeCloudProviderModal,
    imageRegionId,
    lineItemId,
  } = useCloudProviderContext()

  const [selectedImageIds, setSelectedImageIds] = useState<EntityId[]>([])
  const process = useProcessActions()

  const hasSelectedImages = selectedImageIds.length > 0

  const handleImageSelect = (id: EntityId) => {
    if (imageRegionId) {
      setSelectedImageIds(prev => {
        if (prev.find(selectedId => selectedId === id)) {
          return []
        } else {
          return [id]
        }
      })
    } else {
      setSelectedImageIds(prev => {
        if (prev.find(selectedId => selectedId === id)) {
          return prev.filter(selectedId => selectedId !== id)
        } else {
          return [...prev, id]
        }
      })
    }
  }

  const handleUploadImages = async (images: CloudImage[]) => {
    setIsImportingImages(true)
    if (imageRegionId) {
      const imageUrl = images[0]!.url
      process.replaceImageRegionImageWithImageUrl({
        imageRegionId,
        imageUrl,
        onComplete: async () => {
          setSelectedImageIds([])
          await wait(1000)
          setIsImportingImages(false)
          closeCloudProviderModal()
        },
      })
    } else if (lineItemId) {
      const imageUrls = images.map(image => image.url)
      process.fillLineItemImageRegionsWithImageUrls({
        lineItemId,
        imageUrls,
        onComplete: async () => {
          setSelectedImageIds([])
          await wait(1000)
          setIsImportingImages(false)
          closeCloudProviderModal()
        },
      })
    } else {
      const imageUrls = images.map(image => image.url)
      process.createLineItemForProductIdWithImageUrl({
        imageUrls,
        onComplete: async () => {
          setSelectedImageIds([])
          await wait(1000)
          setIsImportingImages(false)
          closeCloudProviderModal()
        },
      })
    }
  }

  return {
    selectedImageIds,
    hasSelectedImages,
    isImportingImages,
    handleImageSelect,
    handleUploadImages,
    closeCloudProviderModal,
  }
}
